import { Updater } from "widgets-for-react";
import { State } from "../../root/root.state";
import { getCookie, setCookie } from "../../../../Shared/Frontend/utils/cookies";

const pageVisitsCookieName = "pageVisits"
export const updatePageViewBasedOnState = (u: Updater<State>, currentState: State) => {
  const newState = u(currentState)

  const slug0 = (currentState.page.params as any).slug
  const slug1 = (newState.page.params as any).slug
  if (slug0 !== slug1) {
    // We changed the slug here, so we made a page change
    let visits = Number.parseInt(getCookie(pageVisitsCookieName))
    if (Number.isNaN(visits)) visits = 0
    setCookie(pageVisitsCookieName, `${visits + 1}`, 0)
  }

  return newState
}